/**--external-- */
import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import { IconDisclosure, Badge } from "@toddle-edu/ds-web";
import { FilterOutlined } from "@toddle-edu/ds-icons";

/**--internal-- */

const MoreFiltersButton = props => {
  const { onButtonClick, isActivated, activeMoreFiltersCount } = props;

  return (
    <Badge
      size="medium"
      value={activeMoreFiltersCount}
      placement="topRight"
      variant="filter"
      type="numeric"
    >
      <IconDisclosure
        variant="outlined-subtle"
        size={"medium"}
        icon={<FilterOutlined />}
        onClick={onButtonClick}
        isActivated={isActivated}
      />
    </Badge>
  );
};

MoreFiltersButton.defaultProps = {
  onButtonClick: _.noop,
  isActivated: false,
  activeMoreFiltersCount: 0,
};

MoreFiltersButton.propTypes = {
  onButtonClick: PropTypes.func,
  isActivated: PropTypes.bool,
  activeMoreFiltersCount: PropTypes.number,
};

MoreFiltersButton.displayName = "MoreFiltersButton";

export default MoreFiltersButton;
